<template>
  <v-container class="doctor-features">
    <section>
      <h3 class="text-h5 text-md-h4 mb-6 mb-md-12">
        Для работы с расписанием и медицинскими документами
      </h3>

      <v-row>
        <v-col
          v-if="locale.isRu"
          cols="12"
          md="4"
        >
          <div class="doctor-features__feature-block rounded-xl bg-ui-kit-bg-secondary">
            <div class="doctor-features__feature-title">
              <p class="text-landing-h5">
                Просматривайте своё расписание
              </p>

              <p class="text-body-1 text-ui-kit-text-secondary my-4">
                Актуальные данные прямо из МИС клиник, в которых вы работаете
              </p>
            </div>

            <LandingFeatureImage
              class="mr-n6 ml-n3"
              sm-width="100%"
              alt="Расписание на сайте МедТочка для врача"
              src="/images/features/doctor/schedule.png"
              sm-src-set="
                /images/features/doctor/schedule-mobile-1x.png 1x,
                /images/features/doctor/schedule-mobile-3x.png 3x
              "
            />
          </div>
        </v-col>

        <v-col
          v-if="locale.isRu"
          cols="12"
          md="4"
        >
          <div class="doctor-features__feature-block rounded-xl bg-ui-kit-bg-secondary">
            <div class="doctor-features__feature-title">
              <p class="text-landing-h5">
                Записывайте пациентов на приём
              </p>

              <p class="text-body-1 text-ui-kit-text-secondary my-4">
                Можете без администратора сами записать к себе пациента
              </p>
            </div>

            <LandingFeatureImage
              class="mr-n6 ml-n3"
              sm-width="100%"
              alt="Запись на приём на сайте МедТочка для врача"
              src="/images/features/doctor/appointment.png"
              sm-src-set="
                /images/features/doctor/appointment-mobile-1x.png 1x,
                /images/features/doctor/appointment-mobile-3x.png 3x
              "
            />
          </div>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <div class="doctor-features__feature-block rounded-xl bg-ui-kit-bg-secondary">
            <div class="doctor-features__feature-title">
              <p class="text-landing-h5">
                Смотрите медкарту пациента онлайн
              </p>

              <p class="text-body-1 text-ui-kit-text-secondary my-4">
                Анкета для анамнеза, результаты обследований и заключения коллег
              </p>
            </div>

            <LandingFeatureImage
              class="mr-n6 ml-n3"
              sm-width="100%"
              alt="Медкарта на сайте МедТочка для врача"
              src="/images/features/doctor/medcard.png"
              sm-src-set="
                /images/features/doctor/medcard-mobile-1x.png 1x,
                /images/features/doctor/medcard-mobile-3x.png 3x
              "
            />
          </div>
        </v-col>

        <v-col
          v-if="locale.isRu"
          cols="12"
          md="4"
        >
          <div class="doctor-features__feature-block rounded-xl bg-ui-kit-bg-secondary">
            <div class="doctor-features__feature-title">
              <p class="text-landing-h5">
                Проводите <span class="text-no-wrap">онлайн-консультации</span>
              </p>

              <p class="text-body-1 text-ui-kit-text-secondary my-4">
                Можете сами настроить своё расписание по онлайн-консультациям
              </p>
            </div>

            <LandingFeatureImage
              class="mr-n6 ml-n3"
              sm-width="100%"
              alt="Медкарта на сайте МедТочка для врача"
              src="/images/features/doctor/telemed.png"
              sm-src-set="
                /images/features/doctor/telemed-mobile-1x.png 1x,
                /images/features/doctor/telemed-mobile-3x.png 3x
              "
            />
          </div>
        </v-col>

        <v-col
          v-if="locale.isRu"
          cols="12"
          md="4"
        >
          <div class="doctor-features__feature-block rounded-xl bg-ui-kit-bg-secondary">
            <div class="doctor-features__feature-title">
              <p class="text-landing-h5">
                Не переживайте о безопасности данных
              </p>

              <p class="text-body-1 text-ui-kit-text-secondary my-4">
                Двойное шифрование обеспечивает соблюдение требований 152-ФЗ
              </p>
            </div>

            <LandingFeatureImage
              class="mr-n6 ml-n3"
              sm-width="100%"
              alt="Медкарта на сайте МедТочка для врача"
              src="/images/features/doctor/security.png"
              sm-src-set="
                /images/features/doctor/security-mobile-1x.png 1x,
                /images/features/doctor/security-mobile-3x.png 3x
              "
            />
          </div>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <div class="doctor-features__feature-block rounded-xl bg-ui-kit-bg-secondary">
            <div class="doctor-features__feature-title">
              <p class="text-landing-h5">
                Отправляйте свои заключения в медкарту
              </p>

              <p class="text-body-1 text-ui-kit-text-secondary my-4">
                Пациент получит их в своё приложение и не потеряет
              </p>
            </div>

            <LandingFeatureImage
              class="mr-n6 ml-n3"
              sm-width="100%"
              alt="Медкарта на сайте МедТочка для врача"
              src="/images/features/doctor/documents.png"
              sm-src-set="
                /images/features/doctor/documents-mobile-1x.png 1x,
                /images/features/doctor/documents-mobile-3x.png 3x
              "
            />
          </div>
        </v-col>

        <v-col
          v-if="locale.isCis"
          cols="12"
          md="4"
        >
          <div class="doctor-features__feature-block rounded-xl bg-ui-kit-bg-secondary">
            <div class="doctor-features__feature-title">
              <p class="text-landing-h5">
                Будьте уверены в безопасности данных
              </p>

              <p class="text-body-1 text-ui-kit-text-secondary my-4">
                Данные хранятся в защищённом дата-центре на территории РФ
              </p>
            </div>

            <LandingFeatureImage
              class="mr-n6 ml-md-n3"
              sm-width="100%"
              height="311"
              alt="Медкарта на сайте МедТочка для врача"
              src="/images/features/doctor/security-cis.png"
              sm-src-set="
                /images/features/doctor/security-cis-mobile-1x.png 1x,
                /images/features/doctor/security-cis-mobile-3x.png 3x
              "
            />
          </div>
        </v-col>
      </v-row>

      <v-sheet
        v-if="locale.isRu"
        class="mt-4 pa-6 d-flex rounded-xl align-center bordered-sheet flex-column flex-md-row"
        elevation="0"
      >
        <v-sheet
          class="flex-grow-1"
          max-width="849"
        >
          <div class="text-h6 text-md-landing-h5">
            Пройдите курс по электронной медкарте<br />и получите медаль на ПроДокторов
          </div>
          <div class="mt-2 text-ui-kit-text-secondary text-body-1 text-md-landing-body-2">
            За 10 минут расскажем, как работать с медкартой МедТочка, и после короткого<br />
            теста добавим медаль в ваш профиль на ПроДокторов.
          </div>
        </v-sheet>

        <LandingFeatureBtn
          breakpoint="md"
          class="mt-8 mt-md-0 ml-md-6"
          text="Пройти курс"
          width="205"
          href="https://academy.medrocket.ru/course/view.php?id=22"
          target="_blank"
          variant="tonal"
        />
      </v-sheet>

      <div class="d-flex justify-center mt-4 mt-md-12">
        <LandingFeatureBtn
          text="Начать работать с МедТочкой"
          target="_blank"
          :href="locale.mtVrachUrl"
        />
      </div>
    </section>
  </v-container>
</template>

<script setup lang="ts">
const locale = useAppLocale()
</script>

<style lang="scss" scoped>
@use '@/assets/vuetify/settings';
@use 'sass:map';

.doctor-features {
  margin-bottom: 32px;

  @media #{map.get(settings.$display-breakpoints, 'md-and-up')} {
    margin-bottom: 88px;
  }

  &__feature-block {
    overflow: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 24px 24px 0;
  }
}
</style>
